import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Spinner, Center } from "@chakra-ui/react";
import { verifyUserAPI } from "helpers/backend_helper";
import Loader from "components/LoadingScreen/ApplicationLoader";
const PrivateRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null); // null = loading
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("sessionToken") ?? sessionStorage.getItem("sessionToken");
      if (!token) {
        setChecking(false);
        setIsValid(false);
        return;
      }

      try {
        const res = await verifyUserAPI();
        if (res?.status === true) {
          setIsValid(true);
        } else {
          localStorage.removeItem("sessionToken");
          sessionStorage.removeItem("sessionToken");
          setIsValid(false);
        }
      } catch (err) {
        console.error("Token validation failed:", err);
        localStorage.removeItem("sessionToken");
        sessionStorage.removeItem("sessionToken");
        setIsValid(false);
      } finally {
        setChecking(false);
      }
    };

    verifyToken();
  }, []);

  // Still checking
  if (checking || isValid === null) {
    console.log("not a valid");
    return (
      <Loader/>
    );
  }

  // Invalid token → redirect
  if (!isValid) {
    console.log("not valid");
    return <Navigate to="/auth/login" replace />;
  }

  // Valid → allow access
  return children;
};

export default PrivateRoute;
